import { SourcePanel } from '../types';

export function getPanelReferenceImageUrls(panel: SourcePanel): string[] {
    if (panel.mediaType === 'VIDEO') {
        const urls = [panel.firstFrameUrl, panel.imagePath].filter(
            (u): u is string => typeof u === 'string' && u.trim().length > 0
        );
        return Array.from(new Set(urls));
    }
    if (panel.imagePath && panel.imagePath.trim().length > 0) return [panel.imagePath];
    return [];
}

export function panelHasReferenceImages(panel: SourcePanel): boolean {
    return getPanelReferenceImageUrls(panel).length > 0;
}

/** Preview URLs for a saved visual-plan reference row (supports VIDEO first+end). */
export function visualPlanRefPreviewUrls(ref: {
    sourceUrls?: string[];
    sourceUrl?: string;
}): string[] {
    if (Array.isArray(ref.sourceUrls) && ref.sourceUrls.length > 0) {
        return Array.from(new Set(ref.sourceUrls.filter((u) => typeof u === 'string' && u.trim())));
    }
    if (ref.sourceUrl && String(ref.sourceUrl).trim()) return [ref.sourceUrl];
    return [];
}
